import React, { useEffect, useState } from 'react'
import './ProductoDetalleCantidad.scss'
import CantidadComponent from './CantidadComponent.jsx'
import { DobleGuion } from './DobleGuion';
import { connect } from 'react-redux'
import { setQuantitySelected } from '../actions/index'

const ProductoDetalleCantidad = (props) => {
    const [numberInit, setNumberInit] = useState(1)
    const [min, setMin] = useState(1)

    useEffect(() => {
        if (props.formatSelected === 'UVenta2021Suelto') {
            setNumberInit(parseInt(props.producto.UVenta2021Suelto))
            setMin(parseInt(props.producto.UVenta2021Suelto))
            props.setQuantitySelected(parseInt(props.producto.UVenta2021Suelto))
        } else if (props.formatSelected === 'UnidadesPack') {
            setNumberInit(parseInt(props.producto.UVenta2021))
            setMin(parseInt(props.producto.UVenta2021))
            props.setQuantitySelected(parseInt(props.producto.UVenta2021))
        } else {
            setNumberInit(1)
            setMin(1)
            props.setQuantitySelected(1)
        }
    }, [props.formatSelected, props.producto])

    const handleClickChange = (quantity) => {
        setNumberInit(quantity)
        props.setQuantitySelected(quantity)
    }

    return (
        <div className="producto-detalle-cantidad">
            <div className="titulo"><p>Cantidad</p> <DobleGuion /></div>
            <div className="selector">
                <CantidadComponent numberInit={numberInit} formatSelected={props.formatSelected} onClick={handleClickChange} />
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    setQuantitySelected
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductoDetalleCantidad)